import { Helpers } from '../../helpers';
import { IForecastDeclineCurveType } from '../../interfaces/iforecast-decline-curve-type';
import { ForecastParameterDetail } from '../forecast-parameter-detail';
import { TypeCurveParameter } from '../type-curve-parameter';

export class ForecastDeclineCurveTypeBase {
  ForecastDeclineCurveTypeId: number;
  Name: string;
  UpdatedBy: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;

  ForecastParameterDetails_ForecastDeclineCurveType?: Array<ForecastParameterDetail> | null;
  TypeCurveParameters_ForecastDeclineCurveType?: Array<TypeCurveParameter> | null;

  constructor(item?: IForecastDeclineCurveType) {
    if (item) {

      this.ForecastDeclineCurveTypeId = item.ForecastDeclineCurveTypeId;
      this.Name = item.Name;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;

      this.ForecastParameterDetails_ForecastDeclineCurveType = Helpers.createClassArray(ForecastParameterDetail, item.ForecastParameterDetails_ForecastDeclineCurveType);
      this.TypeCurveParameters_ForecastDeclineCurveType = Helpers.createClassArray(TypeCurveParameter, item.TypeCurveParameters_ForecastDeclineCurveType);
    }
  }
}